module.exports = require("./ta.d.ts");